import classNames from 'classnames';
import FileSvg from 'components/svg/FileSvg';
import PlusPlacementSvg from 'components/svg/PlusPlacementSvg';
import P from 'components/ui/P';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { FC } from 'react';
import styles from './index.module.scss';

interface Props {
  href: string;
  className?: string;
  countStandard: number;
  countPremium: number;
  onClick?: () => void;
}

const Placements: FC<Props> = ({ href, className, onClick, countStandard = 0, countPremium }) => {
  const t = useTranslations();
  return (
    <Link href={href} className={classNames(styles.link, className)} onClick={onClick}>
      <div className={styles.content}>
        {countStandard >= 0 && (
          <>
            <FileSvg />
            <P styleType={[]}>{countStandard}</P>
          </>
        )}
        {countPremium > 0 && (
          <>
            <div className={styles.premium}>
              <FileSvg />
            </div>
            <P>{countPremium}</P>
          </>
        )}
        {countStandard === 0 && countPremium === 0 && (
          <P>{t('placement_plural', { count: Math.max(countStandard, countPremium) })}</P>
        )}
        <div className={styles.icon}>
          <PlusPlacementSvg />
        </div>
      </div>
    </Link>
  );
};

export default Placements;
